<template>
  <div class="row">
    <div class="col-md-12">
      <base-crud
        :ref="'chipsCrud'"
        :crudName="$t('Chips')"
        :newText="$t('Add') + '  ' + $t('New')"
        :table="table"
        :columns="columns"
        :options="options"
        :endPoint="endPoint"
        :enableAdd="true"
        :enableEdit="true"
        :enableDelete="true"
        :enableView="false"
        :enableReset="false"
        :dataForm="dataForm"
      >
      </base-crud>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "chipsTable",
      showMessageImport: false,
      chipsCrud: {},
      pages: [],
      url: "",
      columns: ["id", "telephone", "operator_id", "iccid", "actions"],
      tableData: ["id", "telephone"],
      optionsOrigin: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["id", "telephone", "operator_id", "iccid"],
        sortable: ["id", "telephone", "operator_id", "iccid"],
        sortIcon: {
          base: "fa fa-sort",
          up: "fa fa-sort-up",
          down: "fa fa-sort-down",
        },
        pagination: {
          chunk: 10,
          dropdown: false,
          nav: "scroll",
        },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: this.$t("id"),
          telephone: this.$t("Telephone"),
          operator_id: this.$t("Operator"),
          iccid: this.$t("Integrated Circuit Card Identifier"),
          actions: this.$t("action"),
        },

        texts: {
          filterBy: this.$t("Filter"),
          defaultOption: this.$t("Select"),
        },
        listColumns: {
          operator_id: [],
        },
        templates: {
          operator_id: function (h, row, index) {
            return row.operator ? row.operator.name : "";
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["operator"];

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this),
          );
        },
      },
      endPoint: "chips",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  computed: {
    options() {
      const headings = {
        id: this.$t("id"),
        telephone: this.$t("Telephone"),
        operator_id: this.$t("Operator"),
        iccid: this.$t("Integrated Circuit Card Identifier"),
        actions: this.$t("action"),
      };

      const texts = {
        filterBy: this.$t("Filter"),
        defaultOption: this.$t("Select"),
      };

      return {
        ...this.optionsOrigin,
        texts,
        headings,
      };
    },
  },

  // add filtro telefone 

  methods: {
    query: function (query) {
      let columns = {
        id: "id",
        telephone: "telephone",
        operator_id: "operator_id",
        iccid: "iccid",
      };

      let filters = "";
      $.each(query, function (index, value) {
        if (index === "telephone") {
          var digits = String(value || "").replace(/\D/g, "");

          if (digits.length > 0) {
         
            if (digits.length <= 2) {
              value = "(" + digits + ")";
            } else {
              var ddd = digits.slice(0, 2);
              var rest = digits.slice(2);

      
              if (rest.length <= 4) {
                value = "(" + ddd + ") " + rest;
              } else if (rest.length <= 8) {
               
                value =
                  "(" + ddd + ") " + rest.slice(0, 4) + "-" + rest.slice(4);
              } else {
                
                value =
                  "(" + ddd + ") " + rest.slice(0, 5) + "-" + rest.slice(5, 9);
              }
            }
          }
        }

        filters += columns[index] + "=" + value + "&";
      });

      return filters;
    },
  },

  mounted() {
    let api = this.$store.state.api + "operators";
    axios
      .get(api)
      .then((res) => {
        const operators = res.data.data || res.data;
        this.optionsOrigin.listColumns.operator_id = operators.map((f) => ({
          id: f.id,
          text: f.name,
        }));
      })
      .catch((err) => {
        console.error("Error loading operators:", err);
      });
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>
